import { Paper, Skeleton, Stack } from "@mui/material"
import React from "react"
import { useParams } from "react-router-dom"

import { PriceDisplay } from "../PriceDisplay"
import { SectionInfo } from "../SectionInfo"
import { SimpleNumberFormat } from "../SimpleNumberFormat"
import useHopperPrice from "@/hooks/useHopper"
import useTokenDetails from "@/hooks/useTokenDetails"

export default function TokenStats() {
  const { tokenId } = useParams()
  const { data: token, isLoading } = useTokenDetails(tokenId ?? "")
  const { data: tokenPrice = 0, isLoading: isTokenPriceLoading } = useHopperPrice(
    tokenId ?? "",
    "usd",
  )

  if (isLoading || !token) {
    return <div>Loading...</div>
  }

  const marketCap = (token.TotalSupply / 10 ** token.Denomination) * tokenPrice

  return (
    <Paper sx={{ padding: 2 }}>
      <Stack gap={1}>
        {isTokenPriceLoading ? (
          <Skeleton />
        ) : (
          <SectionInfo
            title="Current Price"
            value={<PriceDisplay amount={tokenPrice} decimals={4} />}
          />
        )}
        {isTokenPriceLoading ? (
          <Skeleton />
        ) : (
          <SectionInfo title="Market Cap" value={<PriceDisplay amount={marketCap} />} />
        )}
        <SectionInfo
          title="Total Supply"
          value={
            <SimpleNumberFormat
              amount={token.TotalSupply ?? 0}
              tokenId={tokenId}
              needsParsing
              currency={false}
            />
          }
        />
      </Stack>
    </Paper>
  )
}
